/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  CustomQuestionnaire,
  CustomQuestionnaireAnswerCount,
  CustomQuestionnaireAnswerSet,
  CustomQuestionnaireAnswerSetRead,
  PaginatedCustomQuestionnaireAnswerSetSummaryList,
  PaginatedCustomQuestionnaireSummaryList,
  PrefillRequest,
  PrefillResponse,
} from '../models/index';
import {
  CustomQuestionnaireFromJSON,
  CustomQuestionnaireToJSON,
  CustomQuestionnaireAnswerCountFromJSON,
  CustomQuestionnaireAnswerCountToJSON,
  CustomQuestionnaireAnswerSetFromJSON,
  CustomQuestionnaireAnswerSetToJSON,
  CustomQuestionnaireAnswerSetReadFromJSON,
  CustomQuestionnaireAnswerSetReadToJSON,
  PaginatedCustomQuestionnaireAnswerSetSummaryListFromJSON,
  PaginatedCustomQuestionnaireAnswerSetSummaryListToJSON,
  PaginatedCustomQuestionnaireSummaryListFromJSON,
  PaginatedCustomQuestionnaireSummaryListToJSON,
  PrefillRequestFromJSON,
  PrefillRequestToJSON,
  PrefillResponseFromJSON,
  PrefillResponseToJSON,
} from '../models/index';

export interface ApiCustomQuestionnaireAnswerCreateRequest {
  customQuestionnaireAnswerSet: Omit<
    CustomQuestionnaireAnswerSet,
    'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'
  >;
}

export interface ApiCustomQuestionnaireAnswerDestroyRequest {
  id: number;
}

export interface ApiCustomQuestionnaireAnswerListRequest {
  id?: number;
  isDraft?: boolean;
  page?: number;
  pageSize?: number;
  questionnaire?: Array<string>;
  questionnaireId?: number;
  updatedAtAfter?: Date;
  updatedAtBefore?: Date;
  updatedBy?: string;
  useCase?: Array<string>;
  useCaseId?: number;
}

export interface ApiCustomQuestionnaireAnswerPrefillCreateRequest {
  prefillRequest: PrefillRequest;
}

export interface ApiCustomQuestionnaireAnswerRetrieveRequest {
  id: number;
}

export interface ApiCustomQuestionnaireAnswerUpdateRequest {
  id: number;
  customQuestionnaireAnswerSet: Omit<
    CustomQuestionnaireAnswerSet,
    'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'
  >;
}

export interface ApiCustomQuestionnaireCreateRequest {
  customQuestionnaire: Omit<CustomQuestionnaire, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'>;
}

export interface ApiCustomQuestionnaireDestroyRequest {
  id: number;
}

export interface ApiCustomQuestionnaireListRequest {
  page?: number;
  pageSize?: number;
}

export interface ApiCustomQuestionnaireRetrieveRequest {
  id: number;
}

export interface ApiCustomQuestionnaireUpdateRequest {
  id: number;
  customQuestionnaire: Omit<CustomQuestionnaire, 'id' | 'createdBy' | 'updatedBy' | 'createdAt' | 'updatedAt'>;
}

/**
 *
 */
export class CustomQuestionnaireApi extends runtime.BaseAPI {
  /**
   * Get the counts of questionnaire answer sets filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiCustomQuestionnaireAnswerCountsRetrieveRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaireAnswerCount>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/counts/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireAnswerCountFromJSON(jsonValue));
  }

  /**
   * Get the counts of questionnaire answer sets filter categories.  Each category is counted against a queryset that has every *other* active filter applied but not its own, so selecting an option never zeroes out the sibling options in the same category.
   */
  async apiCustomQuestionnaireAnswerCountsRetrieve(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaireAnswerCount> {
    const response = await this.apiCustomQuestionnaireAnswerCountsRetrieveRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async apiCustomQuestionnaireAnswerCreateRaw(
    requestParameters: ApiCustomQuestionnaireAnswerCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaireAnswerSet>> {
    if (requestParameters['customQuestionnaireAnswerSet'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaireAnswerSet',
        'Required parameter "customQuestionnaireAnswerSet" was null or undefined when calling apiCustomQuestionnaireAnswerCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CustomQuestionnaireAnswerSetToJSON(requestParameters['customQuestionnaireAnswerSet']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireAnswerSetFromJSON(jsonValue));
  }

  /**
   */
  async apiCustomQuestionnaireAnswerCreate(
    requestParameters: ApiCustomQuestionnaireAnswerCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaireAnswerSet> {
    const response = await this.apiCustomQuestionnaireAnswerCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiCustomQuestionnaireAnswerDestroyRaw(
    requestParameters: ApiCustomQuestionnaireAnswerDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireAnswerDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   */
  async apiCustomQuestionnaireAnswerDestroy(
    requestParameters: ApiCustomQuestionnaireAnswerDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiCustomQuestionnaireAnswerDestroyRaw(requestParameters, initOverrides);
  }

  /**
   */
  async apiCustomQuestionnaireAnswerListRaw(
    requestParameters: ApiCustomQuestionnaireAnswerListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCustomQuestionnaireAnswerSetSummaryList>> {
    const queryParameters: any = {};

    if (requestParameters['id'] != null) {
      queryParameters['id'] = requestParameters['id'];
    }

    if (requestParameters['isDraft'] != null) {
      queryParameters['is_draft'] = requestParameters['isDraft'];
    }

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    if (requestParameters['questionnaire'] != null) {
      queryParameters['questionnaire'] = requestParameters['questionnaire'];
    }

    if (requestParameters['questionnaireId'] != null) {
      queryParameters['questionnaire__id'] = requestParameters['questionnaireId'];
    }

    if (requestParameters['updatedAtAfter'] != null) {
      queryParameters['updated_at_after'] = (requestParameters['updatedAtAfter'] as any).toISOString();
    }

    if (requestParameters['updatedAtBefore'] != null) {
      queryParameters['updated_at_before'] = (requestParameters['updatedAtBefore'] as any).toISOString();
    }

    if (requestParameters['updatedBy'] != null) {
      queryParameters['updated_by'] = requestParameters['updatedBy'];
    }

    if (requestParameters['useCase'] != null) {
      queryParameters['use_case'] = requestParameters['useCase'];
    }

    if (requestParameters['useCaseId'] != null) {
      queryParameters['use_case__id'] = requestParameters['useCaseId'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedCustomQuestionnaireAnswerSetSummaryListFromJSON(jsonValue),
    );
  }

  /**
   */
  async apiCustomQuestionnaireAnswerList(
    requestParameters: ApiCustomQuestionnaireAnswerListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCustomQuestionnaireAnswerSetSummaryList> {
    const response = await this.apiCustomQuestionnaireAnswerListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Suggest an answer for a single questionnaire question using AI, based on previously answered questionnaires for the same use case.
   */
  async apiCustomQuestionnaireAnswerPrefillCreateRaw(
    requestParameters: ApiCustomQuestionnaireAnswerPrefillCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PrefillResponse>> {
    if (requestParameters['prefillRequest'] == null) {
      throw new runtime.RequiredError(
        'prefillRequest',
        'Required parameter "prefillRequest" was null or undefined when calling apiCustomQuestionnaireAnswerPrefillCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/prefill/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: PrefillRequestToJSON(requestParameters['prefillRequest']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => PrefillResponseFromJSON(jsonValue));
  }

  /**
   * Suggest an answer for a single questionnaire question using AI, based on previously answered questionnaires for the same use case.
   */
  async apiCustomQuestionnaireAnswerPrefillCreate(
    requestParameters: ApiCustomQuestionnaireAnswerPrefillCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PrefillResponse> {
    const response = await this.apiCustomQuestionnaireAnswerPrefillCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiCustomQuestionnaireAnswerRetrieveRaw(
    requestParameters: ApiCustomQuestionnaireAnswerRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaireAnswerSetRead>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireAnswerRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireAnswerSetReadFromJSON(jsonValue));
  }

  /**
   */
  async apiCustomQuestionnaireAnswerRetrieve(
    requestParameters: ApiCustomQuestionnaireAnswerRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaireAnswerSetRead> {
    const response = await this.apiCustomQuestionnaireAnswerRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async apiCustomQuestionnaireAnswerUpdateRaw(
    requestParameters: ApiCustomQuestionnaireAnswerUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaireAnswerSet>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireAnswerUpdate().',
      );
    }

    if (requestParameters['customQuestionnaireAnswerSet'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaireAnswerSet',
        'Required parameter "customQuestionnaireAnswerSet" was null or undefined when calling apiCustomQuestionnaireAnswerUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire_answer/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CustomQuestionnaireAnswerSetToJSON(requestParameters['customQuestionnaireAnswerSet']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireAnswerSetFromJSON(jsonValue));
  }

  /**
   */
  async apiCustomQuestionnaireAnswerUpdate(
    requestParameters: ApiCustomQuestionnaireAnswerUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaireAnswerSet> {
    const response = await this.apiCustomQuestionnaireAnswerUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireCreateRaw(
    requestParameters: ApiCustomQuestionnaireCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaire>> {
    if (requestParameters['customQuestionnaire'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaire',
        'Required parameter "customQuestionnaire" was null or undefined when calling apiCustomQuestionnaireCreate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire/`,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CustomQuestionnaireToJSON(requestParameters['customQuestionnaire']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireCreate(
    requestParameters: ApiCustomQuestionnaireCreateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaire> {
    const response = await this.apiCustomQuestionnaireCreateRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireDestroyRaw(
    requestParameters: ApiCustomQuestionnaireDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireDestroy().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireDestroy(
    requestParameters: ApiCustomQuestionnaireDestroyRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.apiCustomQuestionnaireDestroyRaw(requestParameters, initOverrides);
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireListRaw(
    requestParameters: ApiCustomQuestionnaireListRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<PaginatedCustomQuestionnaireSummaryList>> {
    const queryParameters: any = {};

    if (requestParameters['page'] != null) {
      queryParameters['page'] = requestParameters['page'];
    }

    if (requestParameters['pageSize'] != null) {
      queryParameters['page_size'] = requestParameters['pageSize'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire/`,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      PaginatedCustomQuestionnaireSummaryListFromJSON(jsonValue),
    );
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireList(
    requestParameters: ApiCustomQuestionnaireListRequest = {},
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<PaginatedCustomQuestionnaireSummaryList> {
    const response = await this.apiCustomQuestionnaireListRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireRetrieveRaw(
    requestParameters: ApiCustomQuestionnaireRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaire>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireRetrieve().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireRetrieve(
    requestParameters: ApiCustomQuestionnaireRetrieveRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaire> {
    const response = await this.apiCustomQuestionnaireRetrieveRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireUpdateRaw(
    requestParameters: ApiCustomQuestionnaireUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CustomQuestionnaire>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling apiCustomQuestionnaireUpdate().',
      );
    }

    if (requestParameters['customQuestionnaire'] == null) {
      throw new runtime.RequiredError(
        'customQuestionnaire',
        'Required parameter "customQuestionnaire" was null or undefined when calling apiCustomQuestionnaireUpdate().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token('jwtAuth', []);

      if (tokenString) {
        headerParameters['Authorization'] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/api/custom_questionnaire/{id}/`.replace(
          `{${'id'}}`,
          encodeURIComponent(String(requestParameters['id'])),
        ),
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: CustomQuestionnaireToJSON(requestParameters['customQuestionnaire']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue => CustomQuestionnaireFromJSON(jsonValue));
  }

  /**
   * API endpoint that allows Custom Questionnaires to be viewed.
   */
  async apiCustomQuestionnaireUpdate(
    requestParameters: ApiCustomQuestionnaireUpdateRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CustomQuestionnaire> {
    const response = await this.apiCustomQuestionnaireUpdateRaw(requestParameters, initOverrides);
    return await response.value();
  }
}
